import React from "react";
import MonthlyTimeTable from "./MonthlyTimeTable";



const AugustTimeTable = ({districtDetails }) => {
  return <MonthlyTimeTable month={8} title="August Namaz Time Table" columnKey="12Columns" districtDetails={districtDetails} />;
};

export default AugustTimeTable;
